var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTransfers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 26,
    viewBox: "0 0 25 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4332 19.2069C15.9416 19.2069 18.7858 16.428 18.7858 13C18.7858 9.57201 15.9416 6.79309 12.4332 6.79309C8.92473 6.79309 6.08057 9.57201 6.08057 13C6.08057 16.428 8.92473 19.2069 12.4332 19.2069Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7642 13.4204C18.549 10.4122 15.9902 8.03369 12.8562 8.03369C9.58252 8.03369 6.92798 10.6273 6.92798 13.8276C6.92798 15.5796 7.72756 17.1479 8.98707 18.2097C9.97977 18.8387 11.1622 19.2069 12.4327 19.2069C15.7945 19.2069 18.5405 16.6513 18.7642 13.4204Z",
    fill: "#FCB701"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1 3.48276L5.23507 5.96552V4.31034H10.3172C19.8105 4.31034 20.4813 10.9567 20.4813 11.7586C20.4813 6.87835 18.0546 2.65683 10.3172 2.65517C9.17877 2.65517 5.23507 2.65517 5.23507 2.65517V1L1 3.48276Z",
    fill: "#00DCF5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8688 22.5172L19.6337 20.0344V21.6896H14.5516C5.05829 21.6896 4.38745 15.0433 4.38745 14.2413C4.38745 19.1224 6.81415 23.3448 14.5516 23.3448C15.69 23.3448 19.6337 23.3448 19.6337 23.3448V25L23.8688 22.5172Z",
    fill: "#00DCF5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7405 15.0689C10.8269 15.1815 11.4994 15.8965 12.4345 15.8965C13.3696 15.8965 14.1285 15.2005 14.1285 14.2413C14.1285 13.1266 12.8402 12.7119 12.4345 12.5862C12.0288 12.4604 11.164 12.03 11.164 11.3448C11.164 10.6595 11.7323 10.1034 12.4345 10.1034C12.8894 10.1034 13.4484 10.3335 13.705 10.523",
    stroke: "#07278A",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4348 16.7242V15.8966",
    stroke: "#07278A",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4348 10.1035V9.27588",
    stroke: "#07278A",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0914 7.22837C10.8165 6.94617 11.6076 6.79224 12.4351 6.79224C15.9435 6.79224 18.7877 9.57127 18.7877 13C18.7877 16.4287 15.9435 19.2077 12.4351 19.2077C8.92679 19.2077 6.08252 16.4287 6.08252 13C6.08252 10.9823 7.06844 9.18893 8.59476 8.05431",
    stroke: "#07278A",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8581 21.6896H12.7734",
    stroke: "#07278A",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M4.38818 14.2413C4.38818 19.1216 6.81488 23.3431 14.5524 23.3448C15.6907 23.3448 19.6344 23.3448 19.6344 23.3448V25L23.8695 22.5172L19.6344 20.0344V21.6896H14.5524",
    stroke: "#07278A",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M1.84644 10.0206V10.1034",
    stroke: "#07278A",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M1.84644 11.7585V14.2413C1.84644 17.4416 3.2762 20.315 5.54619 22.2863",
    stroke: "#07278A",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0117 4.3103H12.0964",
    stroke: "#07278A",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4813 11.7586C20.4813 6.87835 18.0546 2.65683 10.3172 2.65517C9.17877 2.65517 5.23507 2.65517 5.23507 2.65517V1L1 3.48276L5.23507 5.96552V4.31034H10.3172",
    stroke: "#07278A",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0225 15.9794V15.8966",
    stroke: "#07278A",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0225 14.2413V11.7586C23.0225 8.55831 21.5928 5.68493 19.3228 3.71362",
    stroke: "#07278A",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7405 15.0689C10.8269 15.1815 11.4994 15.8965 12.4345 15.8965C13.3696 15.8965 14.1285 15.2005 14.1285 14.2413C14.1285 13.1266 12.8402 12.7119 12.4345 12.5862C12.0288 12.4604 11.164 12.03 11.164 11.3448C11.164 10.6595 11.7323 10.1034 12.4345 10.1034C12.8894 10.1034 13.4484 10.3335 13.705 10.523",
    stroke: "#07278A",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4348 16.7242V15.8966",
    stroke: "#07278A",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4348 10.1035V9.27588",
    stroke: "#07278A",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0914 7.22837C10.8165 6.94617 11.6076 6.79224 12.4351 6.79224C15.9435 6.79224 18.7877 9.57127 18.7877 13C18.7877 16.4287 15.9435 19.2077 12.4351 19.2077C8.92679 19.2077 6.08252 16.4287 6.08252 13C6.08252 10.9823 7.06844 9.18893 8.59476 8.05431",
    stroke: "#07278A",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8581 21.6896H12.7734",
    stroke: "#07278A",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M4.38818 14.2413C4.38818 19.1216 6.81488 23.3431 14.5524 23.3448C15.6907 23.3448 19.6344 23.3448 19.6344 23.3448V25L23.8695 22.5172L19.6344 20.0344V21.6896H14.5524",
    stroke: "#07278A",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M1.84644 10.0206V10.1034",
    stroke: "#07278A",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M1.84644 11.7585V14.2413C1.84644 17.4416 3.2762 20.315 5.54619 22.2863",
    stroke: "#07278A",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0117 4.3103H12.0964",
    stroke: "#07278A",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4813 11.7586C20.4813 6.87835 18.0546 2.65683 10.3172 2.65517C9.17877 2.65517 5.23507 2.65517 5.23507 2.65517V1L1 3.48276L5.23507 5.96552V4.31034H10.3172",
    stroke: "#07278A",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0225 15.9794V15.8966",
    stroke: "#07278A",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0225 14.2413V11.7586C23.0225 8.55831 21.5928 5.68493 19.3228 3.71362",
    stroke: "#07278A",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransfers);
export default __webpack_public_path__ + "static/media/transfers.775a52d2305cb1a8f17b7e150f2ce0c7.svg";
export { ForwardRef as ReactComponent };